import Vue from "/srv/www/g/guidanceineurope.nl/vhosts/www/htdocs/content/mu-plugins/wp-soup-plugin/node_modules/vue/dist/vue";
import App from "./App.vue";

Vue.config.productionTip = false;

if (document.getElementById('dashboard-map')) {
  new Vue({
    render: h => h(App)
  }).$mount("#dashboard-map");
}